var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStripTags = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M8.279 13.506a.42.42 0 0 0 .616-.373q0-.079-.04-.143a.3.3 0 0 0-.13-.114l-1.433-.739a2 2 0 0 0-.19-.08c-.054-.018-.054-.104 0-.12q.1-.037.19-.084l1.433-.734a.33.33 0 0 0 .13-.11.3.3 0 0 0 .04-.147.42.42 0 0 0-.616-.374l-2.336 1.219a.326.326 0 0 0 0 .577zm7.449 0a.42.42 0 0 1-.615-.373q0-.079.039-.143a.3.3 0 0 1 .13-.114l1.434-.739a2 2 0 0 1 .19-.08c.054-.018.053-.104 0-.12a2 2 0 0 1-.19-.084l-1.434-.734a.33.33 0 0 1-.13-.11.3.3 0 0 1-.04-.147c0-.316.336-.52.617-.374l2.336 1.219a.326.326 0 0 1 0 .577zm-4.401 1.144a.5.5 0 0 1-.217.258.57.57 0 0 1-.304.092h-.411l2.306-5.67a.53.53 0 0 1 .194-.243.52.52 0 0 1 .304-.087h.414z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStripTags);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/strip-tags.08fe2e0e.svg";